import React from 'react'
import { Row as AntRow, Col as AntCol, Select as AntSelect, Input as AntInput, InputNumber, Spin } from 'antd'
import { CURRENCY_FORMATTER, CURRENCY_PARSER } from '../../../common/utils/fees'

/**
 * Uniform order row for product selection and additional fee entry
 * This component controls the entire row layout so both variants stay identical.
 */
const OrderRow = ({
  kind, // 'product' | 'fee'
  // Left side props (input/select)
  productValue, // object or id
  productOptions = [], // [{ id, description }]
  onProductChange,
  leftDisabled = false,
  descriptionValue,
  onDescriptionChange,
  descriptionError, // validation error message shown below description input (fee kind only)
  // Right side props (amount/actions)
  amountValue,
  onAmountChange,
  amountDisabled = false,
  amountLoading = false,
  infoIcon = null,
  showRemove = false,
  onRemove,
}) => {
  const rowStyle = { marginBottom: '1px' }
  const leftColStyle = undefined
  const controlStyle = { width: '100%' }
  const rightColStyle = { display: 'flex', alignItems: 'center', gap: 8 }

  return (
    <>
      <style>{`
        .modern-disabled-input.ant-input[disabled],
        .modern-disabled-input.ant-input-number[disabled],
        .modern-disabled-input .ant-input-number-input[disabled] {
          background-color: #fafafa !important;
          border-color: #d9d9d9 !important;
          color: #000000d9 !important;
          cursor: not-allowed !important;
          opacity: 1 !important;
        }
        .modern-disabled-input .ant-input-number-handler-wrap {
          background-color: #fafafa !important;
          border-color: #d9d9d9 !important;
        }
        .ant-input:-webkit-autofill,
        .ant-input:-webkit-autofill:hover,
        .ant-input:-webkit-autofill:focus,
        .ant-input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 30px white inset !important;
          box-shadow: 0 0 0 30px white inset !important;
        }
      `}</style>
      <AntRow gutter={8} style={rowStyle}>
        <AntCol span={18} style={leftColStyle}>
          {kind === 'product' ? (
            <AntSelect
              style={controlStyle}
              size="large"
              placeholder="Select..."
              value={productValue?.description || productValue}
              disabled={leftDisabled}
              onChange={(value) => {
                const selected = productOptions.find((p) => (p.id ?? p.value) === value)
                onProductChange?.(selected || value)
              }}
              options={productOptions.map((p) => ({
                label: p.description ?? p.label,
                value: p.id ?? p.value,
                title: p.description ?? p.label, // This shows full text on hover
              }))}
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
              dropdownClassName="wrapped-dropdown"
            />
          ) : (
            <AntInput
              className={leftDisabled ? 'modern-disabled-input' : ''}
              style={controlStyle}
              name="description"
              value={descriptionValue}
              onChange={onDescriptionChange}
              placeholder="Description"
              size="large"
              disabled={leftDisabled}
            />
          )}
        </AntCol>

        <AntCol span={6} style={rightColStyle}>
          {amountLoading ? (
            <div
              style={{
                width: 110,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                paddingLeft: 12,
              }}
            >
              <Spin size="small" />
            </div>
          ) : (
            <>
              <InputNumber
                className={amountDisabled ? 'modern-disabled-input' : ''}
                style={{ width: 110 }}
                value={amountValue}
                onChange={onAmountChange}
                size="large"
                disabled={amountDisabled}
                formatter={CURRENCY_FORMATTER}
                parser={CURRENCY_PARSER}
              />
              {infoIcon}
            </>
          )}
          {showRemove ? (
            <i
              className="fa fa-minus-circle"
              aria-hidden="true"
              onClick={onRemove}
              style={{ color: '#ff4d4f', fontSize: 18, cursor: 'pointer' }}
            />
          ) : null}
        </AntCol>
      </AntRow>
      {kind === 'fee' && descriptionError ? (
        <AntRow gutter={8}>
          <AntCol span={24}>
            <div style={{ fontSize: 12, color: '#ff4d4f', marginTop: 2 }}>{descriptionError}</div>
          </AntCol>
        </AntRow>
      ) : null}
    </>
  )
}

export default OrderRow
